export default __webpack_public_path__ + "static/media/Start Kit 20k.a1598643.jpg";